export const generateEndpoint = (devEndpoint, prodEndpoint, awsApiGatewayType = null) => {
  const defaultEndpoint = process.env.REACT_APP_AWS_DEFAULT_ENDPOINT;
  const ehrEndpoint = process.env.REACT_APP_AWS_EHR_DEFAULT_ENDPOINT;

  const endpointSuffix = process.env.REACT_APP_ENV !== "production" ? devEndpoint : prodEndpoint;

  if (awsApiGatewayType === "ehr") {
    return `${ehrEndpoint}${endpointSuffix || ""}`;
  } else {
    return `${defaultEndpoint}${endpointSuffix || ""}`;
  }
};
